/**
 * StatusBadge Component
 * Displays prediction status with consistent styling from design system
 */

import { Chip } from '@mui/material';
import { getStatusConfig, PredictionStatus } from '../../utils/designSystem';

interface StatusBadgeProps {
  status: PredictionStatus;
  size?: 'small' | 'medium';
}

export default function StatusBadge({ status, size = 'small' }: StatusBadgeProps) {
  const config = getStatusConfig(status);
  
  return (
    <Chip
      label={config.label}
      size={size}
      sx={{
        backgroundColor: config.backgroundColor,
        color: config.color,
        fontWeight: 600,
        fontSize: '0.6875rem', // 11px
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        height: size === 'small' ? '20px' : '24px',
        borderRadius: '12px',
        '& .MuiChip-label': {
          padding: '2px 8px',
        },
      }}
    />
  );
}
